import { APPROVAL_CHAINS, findApprovalChain } from '@dlap-ui/core/approval-chains';

export interface ApplicationLifecycle {
  applicationType: string;
  chainId: string;
  entryStatuses: string[];
  terminalStatus: string;
  sequence: string[];
  steps: { role: string; from: string[]; to: string }[];
}

export const DEEDS_OFFICE_ROLES = [
  'FINANCE_OFFICER',
  'EXAMINER',
  'REGISTRAR',
  'REGISTRY',
];

const cache = new Map<string, ApplicationLifecycle>();

export function applicationLifecycle(applicationType: string): ApplicationLifecycle {
  const cached = cache.get(applicationType);
  if (cached) return cached;
  const chain = findApprovalChain(APPROVAL_CHAINS, applicationType);
  const steps = chain?.steps ?? [];
  const entryStatuses = steps[0]?.from ?? ['SUBMITTED', 'RESUBMITTED'];
  const sequence = [
    entryStatuses[0],
    ...steps.map((step) => step.to),
  ].filter((status, index, all) => all.indexOf(status) === index);
  const lifecycle: ApplicationLifecycle = {
    applicationType,
    chainId: chain?.id ?? applicationType.toLowerCase(),
    entryStatuses,
    terminalStatus: sequence[sequence.length - 1],
    sequence,
    steps: steps.map(({ role, from, to }) => ({ role, from, to })),
  };
  cache.set(applicationType, lifecycle);
  return lifecycle;
}

export function isEntryStatus(applicationType: string, status: string) {
  return applicationLifecycle(applicationType).entryStatuses.includes(status);
}

export function isTerminalStatus(applicationType: string, status: string) {
  return applicationLifecycle(applicationType).terminalStatus === status;
}

export function holderRole(applicationType: string, status: string) {
  const { steps } = applicationLifecycle(applicationType);
  return (
    steps.find((step) => step.from.includes(status))?.role ??
    steps[steps.length - 1]?.role ??
    ''
  );
}
